import {
  Box,
  Container,
  Grid,
  styled,
  useTheme,
} from "@mui/material";

import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import { LANDING_PAGE_URL } from "config/Configuration";
import { SanaCashLogo } from "assets/Icon";
import SideMenuDrawer from "./SideMenuDrawer";
import { useState } from "react";

export function FixedAppBar() {
  const theme = useTheme();
  const [openSideMenu, setOpenSideMenu] = useState(false);

  return (
    <AppBarStyle position="fixed">
      <Container>
        <Grid container alignItems="center" my={1}>
          <Grid item xs={2} textAlign="left">
            <IconButton color="text" onClick={() => setOpenSideMenu(true)}>
              <ion-icon name="menu-outline"></ion-icon>
            </IconButton>
          </Grid>

          <Grid item xs={8} textAlign="center">
            <BoxLogo>
              <a href={LANDING_PAGE_URL}>
                <SanaCashLogo fill={theme.palette.modules.logoColor} />
              </a>
            </BoxLogo>
          </Grid>

          <Grid item xs={2} textAlign="right">

          </Grid>
        </Grid>
      </Container>

      <SideMenuDrawer
        open={openSideMenu}
        onClose={() => setOpenSideMenu(false)}
      />
    </AppBarStyle>
  );
}

const AppBarStyle = styled(AppBar)(({ theme }) => ({
  maxHeight: "50px",
  boxShadow: "0 4px 8px rgb(2 51 103 / 10%)",
  background: theme.palette.modules.navbar,
}));

const BoxLogo = styled(Box)(({ theme }) => ({
  a: {
    maxWidth: "120px",
    display: "flex",
    margin: "auto",
  },
}));

export default FixedAppBar;
